module.exports = __webpack_public_path__ + "img/restaurant-banner-h5-clean.89ab70c8.png";